import React from 'react';
import WName from '../WName';
import QL from './QuestionLink';
import PL from '../problems/ProblemLink';
import AL from '../angles/AngleLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual} from '../common';

// ‘’

export const time = {
  // What is 'time'
  name: "time",
  prelude: <span>To really <LRL>understand</LRL> <WName />, how <i>long</i> does it—<sup>†</sup></span>,
  question: <span>What is ‘time’?</span>,
  headerFootnote: <p>
    † A <QL>joke</QL>, obviously. Haste is the <AL>straitjacket</AL> of <QL>consciousness</QL>.
  </p>,
  answerPreview: <div className="answer-preview">
    <p><AL name="notnew.">Martin Heidegger</AL> saw time as an integral component of ‘<AL name="notnew.p.heidegger.">Dasein</AL>’ (<QL name="languages">Heidegger-German</QL> for being-there.)</p>
    <p>In <AL name="notnew.p.heidegger.">Sein und Zeit</AL> (Being and Time), if Dasein finds its <QL name="life.">meaning</QL> in <i><QL name="life.">death</QL></i>, then ‘<AL name="notnew.p.heidegger.">Dasein</AL>’ is thus a fragment of <QL>consciousness</QL> – a <i>piece</i> of the <AL name="religion.jew.kelal">whole</AL>, cf. <NW>POC</NW> – defined by <i>finitude</i>, cf. the <QL>CT</QL>.</p>
  </div>,
  answer: <div className="answer">
    <p>Thus <AL name="notnew.p.">Heidegger</AL> (and the whole <AL name="framework">field</AL> of ‘phenomenology’) see <NW>kennis-apartheid</NW> as fundamental, not emergent (cf. <AL name="religion.">Buddhism</AL>). <WName cap /> sees ‘time’ as an emergent phenomenon: everything being <PL name="arbitrer">emergent</PL> save the <LRL>imagination</LRL>, which is self-evident, cf. the <QL name="ra">Gedankenexperiment with Ra</QL>. One <E2 word="explanation" /> of it is as per the <PL>characters</PL>’ <QL>metaphor</QL> of <AL>Barbie and Ken</AL> (in the ‘<QL name="languages">biblioteca</QL>’).</p>
  </div>,
};
